import { memo } from 'react';

import MarketingCampaignActivityContent from '../../shared/MarketingCampaignActivityContent';

import './styles.scss';

const MarketingCampaignCardContent = memo(({ campaign }) => {
    return <MarketingCampaignActivityContent campaign={campaign} variant="card" />;
});

MarketingCampaignCardContent.displayName = 'MarketingCampaignCardContent';

export default MarketingCampaignCardContent;
